import { mergeApplicationConfig, Injectable, NgZone } from '@angular/core';
import { ɵɵinject, APP_ID } from '@angular/core';
import { ViewportScroller, DOCUMENT } from '@angular/common';
import { HAMMER_GESTURE_CONFIG, HAMMER_LOADER, HammerGestureConfig } from '@angular/platform-browser';
import { SwRegistrationOptions } from '@angular/service-worker';
// libs
import { REQUEST } from '../express.tokens';
import { ViewportScrollerScrollbar } from './shared/viewport-scroller/viewport-scroller';

import { APOLLO_OPTIONS} from 'apollo-angular';
import { TransferState, makeStateKey } from '@angular/core';

import { ScrollBarService } from './shared/scroll/scrollbar.service';
import { isTouchDevice } from './shared/utilities/device';
import { META_TAG_ROBOTS_ENABLED } from './shared/tokens/meta-tag-robots.enabled';
import { createApollo } from './apollo-links/apollo-link';
import { ApolloLink } from '@apollo/client/core';
import { AuthService } from './shared/auth/auth.service';
import { LOCALE_ID, ErrorHandler, InjectionToken, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { CustomPreloader, RouterOptions, environment } from '@env/environment';
import { SharedModule } from './app.browser.module';
import { appConfig } from './app.config';
import { IntersectionObserverService } from './shared/scroll/intersection-observer.service';


const STATE_KEY = makeStateKey<any>('expo.state');

export function getRequest(): any {
    return { headers: { cookie: document.cookie } };
  }
export function tokenGetter(): string | null {
    return localStorage.getItem('token');
}


const DIRECTION_UP = 8;
@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    // 'pan': { direction: Hammer.DIRECTION_ALL },
    'pinch': { enable: false },
    'rotate': { enable: false }
  };
}


export const TINYMCE_SCRIPT_SRC = new InjectionToken<string>('TINYMCE_SCRIPT_SRC');


export function createApolloBrowser(transferState: TransferState, errorHandler: ErrorHandler): any {
  const middleware = new ApolloLink((operation, forward) => {
    const token =  localStorage?.getItem('token') || null;
    if(token) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          authorization: `Bearer ${localStorage.getItem('token') || null}`,
        }
      }));
    }

    return forward(operation);
  });

  const apolloLink = createApollo(environment.backendUrl, middleware, errorHandler, environment.BACKEND_TIMEOUT);

  const state = transferState.get<any>(STATE_KEY, null);
  apolloLink.cache.restore(state);

  return apolloLink;
}

const browserConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(SharedModule),
        // va disabilitato nel caso dovessimo tornare alla soluzione MetadataServiceBrowser.
        { provide: META_TAG_ROBOTS_ENABLED, useValue: environment.enableMetaTagRobots },
        {
          provide: SwRegistrationOptions,
          useFactory: (lang) => {
            return {
              scope: `/${lang}/`,
              registrationStrategy: 'registerWhenStable:5000',
              enabled: environment.production
            };
          },
          deps: [LOCALE_ID]
        },  {
          // The server provides these in main.server
          provide: REQUEST, useFactory: (getRequest)
        },/*{
          provide: AppStorage, useClass: CookieStorage
        }, */ {
          provide: ViewportScroller,
          useFactory: () => new ViewportScrollerScrollbar( ɵɵinject(DOCUMENT), window, ɵɵinject(ErrorHandler), ɵɵinject(ScrollBarService))
        },
        { provide: HAMMER_LOADER, useValue: async () => {
          if (isTouchDevice()) {
            return import('hammerjs/hammer');
          } else {
            return Promise.resolve(null);
          }
    
        }},
        {
          provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig
        },
        { provide: 'ISTTOUCH', useValue: isTouchDevice() },
        { provide: APP_ID, useValue: 'expo-app' },
        {
          provide: APOLLO_OPTIONS,
          useFactory: createApolloBrowser,
          deps: [TransferState, ErrorHandler]
        },
        {
          provide: 'AppIntersectionObserver',
          useFactory: (zone: NgZone, scrollBarService: ScrollBarService) => {
      
            const viewport = new IntersectionObserverService(zone, scrollBarService);
            viewport.setup(null, '0px 0px 50% 0px');
      
            return (viewport);
      
          },
          
          deps: [NgZone, ScrollBarService]
        }, // Use observable object to control the load time of GPT
        // {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy,
        //   deps: [Location] },
      ]
};

export const appBrowserConfig = mergeApplicationConfig(appConfig, browserConfig);
